<script setup lang="ts">
import { CompanyInfoSelect, Mailing } from '@/@types/participant'
import Form from '@/components/shared/admin/mailings/Index.vue'
import Ticket from '@/components/shared/base_mailing/InfoTicket.vue'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import Title from '@/components/ui/title/Title.vue'
import LightLayout from '@/layouts/LightLayout.vue'
import { Head } from '@inertiajs/vue3'

defineProps<{ mailing: Mailing; company_info_select: CompanyInfoSelect; order_id: number }>()
</script>

<template>
    <Head :title="$t('Manage orders')" />

    <LightLayout contentClasses="bg-slate-50">
        <main class="container grid gap-8 lg:grid-cols-3">
            <section class="lg:col-span-2">
                <Card class="border-none bg-white text-slate-800 shadow-[0_4px_12px_0px_rgba(12,12,13,.08)]">
                    <CardHeader>
                        <Title class="!text-2xl">
                            {{ $t('Complete ticket information') }}
                        </Title>
                        <p class="text-base !font-normal !text-slate-800">
                            {{ $t('By filling in all required fields and saving, your ticket will be generated automatically.') }}
                        </p>
                    </CardHeader>

                    <CardContent class="py-8">
                        <Form :mailing="mailing" :company_info_select="company_info_select" :orderId="order_id" />
                    </CardContent>
                </Card>
            </section>
            <Ticket :mailing="mailing" />
        </main>
    </LightLayout>
</template>
